export default {
    common: {
        title: 'Inteligência de Conteúdo',
        socialPlanner: 'Planeador Social',
        blog: 'Blogue',
        funnel: 'Funil',
        website: 'Site da internet',
        mediaLibrary: 'Biblioteca de mídia',
        email: 'Email',
        words: 'Palavras',
        variations: 'Variações',
        thisIsPaidService: 'Esta funcionalidade é um serviço pago e incorre em encargos com base na sua utilização',
        all: 'Alla',
    },
};
